import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Usuario } from '../models/usuario.model';

const baseUrl = `${environment.URL_API}`;

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  private _usuario: BehaviorSubject<Usuario> = new BehaviorSubject(null);

  constructor(private _httpClient: HttpClient) {
    if (localStorage.getItem('usuario')) {
      try {
        this._usuario.next(JSON.parse(localStorage.getItem('usuario')));
      } catch (error) {
        console.error(
          'JSON do usuario salvo no localhost está fora do padrão.'
        );
        this.usuario = null;
      }
    }
  }

  set usuario(value: Usuario | null) {
    localStorage.removeItem('usuario');
    this._usuario.next(value);

    if (value != null) {
      localStorage.setItem('usuario', JSON.stringify(value));
    }
  }

  get usuario$(): Observable<Usuario> {
    return this._usuario.asObservable();
  }

  checkUsuario(): boolean {
    if (this._usuario.value && this._usuario.value?.cpfCnpj) {
      return true;
    }
    return false;
  }

  solicitarAcesso(dados: any): Observable<any> {
    return this._httpClient.post<any>(`${baseUrl}/acesso/solicitar`, dados);
  }

  esqueciSenha(cnpj: string, email: string): Observable<any> {
    return this._httpClient.post<any>(
      `${baseUrl}/acesso/esqueciSenha/${cnpj}/${email}`,
      null
    );
  }

  ativar(tipo: string, hash: string): Observable<any> {
    return this._httpClient.put<any>(`${baseUrl}/${tipo}/ativar/${hash}`, null);
  }
}
